import React, { useContext } from 'react';
import { style } from 'typestyle';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ChevronRightRounded } from '@mui/icons-material';
import * as styles from '../companies.styles';
import { type CompanyOffice } from '../models/company';
import Column from '../../../core/components/column/column.component';
import Row from '../../../core/components/row/row.component';
import { CrossAxisAlignment, MainAxisAlignment } from '../../../core/components/flex/flex.component';
import { IsMobileContext } from '../../../core/context/is-mobile';
import CommonStyles from '../../../core/common.styles';
import RouteConstants from '../../../core/routes.constants';

interface Props {
  readonly offices?: CompanyOffice[];
}

const CompanyOfficesGroup = ({ offices }: Props): React.JSX.Element => {
  const isMobile = useContext(IsMobileContext);
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className={style(CommonStyles.sectionCard(isMobile), styles.gridRow)}>
      <Column crossAxisAlignment={CrossAxisAlignment.Stretch}>
        <Row>
          <span className={style(styles.columnHeader(isMobile, 8))}>{t('linked-offices').toUpperCase()}</span>
        </Row>

        <div className={style(styles.horizontalDivider)} />

        {offices == null || offices.length === 0 ? (
          <span className={style(styles.emptyListMessage)}>{t('no-linked-offices')}</span>
        ) : (
          offices.map((office, index) => (
            <Row
              key={office.id}
              className={style(styles.officeListItem(index === offices.length - 1))}
              mainAxisAlignment={MainAxisAlignment.SpaceBetween}
              crossAxisAlignment={CrossAxisAlignment.Center}
              onClick={(): void => {
                navigate(`/${RouteConstants.PATH_OFFICES}/${office.id}`);
              }}
            >
              <span>{office.name}</span>
              <ChevronRightRounded sx={styles.officeListChevronSx} />
            </Row>
          ))
        )}
      </Column>
    </div>
  );
};

export default CompanyOfficesGroup;
